import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sliderContainer: {
    paddingBottom: theme.spacing(3),
  },
}))

export default useStyles
